import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';
import { Component, OnInit } from '@angular/core';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';
import { ActivatedRoute,Router } from '@angular/router';
import { DatePipe, formatDate } from '@angular/common';

@Component({
  selector: 'app-drawingcontest',
  templateUrl: './drawingcontest.component.html',
  styleUrls: ['./drawingcontest.component.css']
})
export class DrawingcontestComponent implements OnInit {
  images: any[];
  userId: number;
  currency: any;
  contestId: any;
  drawingDetailsInfo: any;
  ticketPrice: any;
  drawingBannerUrl: any;
  smallDesc: any;
  largeDesc: any;
  prize1Desc: any;
  prize2Desc: any;
  prize3Desc: any;
  startMin: number=0;
  payAmount: number;
  exceed: boolean=true;
  paymentType: string="payment_by_currency";
  paymentDone: boolean=false;
  myDate:any;
  title: any;
  idFor: any;
  getId: any;
  payId: string;
  winners: any;
  showWinner: boolean=false;
  today= new Date();
  jstoday = '';
  tickets: any;
  
  constructor(private service:HitmakerService,private service2:FilmServiceService,private activatedRoute: ActivatedRoute,
    ) { 
      this.jstoday = formatDate(this.today, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0530');


    }
    carouselOptions = {
      loop: true,
      items: 1,
      dots: false,
      nav: true,
      navText: ["<i class='bi bi-caret-left-fill'></i>","<i class='bi bi-caret-right-fill'></i>"],
      autoplay: false,
      autoplayTimeout: 4000, // Adjust autoplay speed
      responsive: {
        0: {
          items: 1,
          margin: 10,
        },
        768: {
          items: 2,
          margin: 20,
        },
        992: {
          items: 4,
          margin: 10,
        },
        1092:{
          items: 4,
          margin: 10
        }
      },
    };
  ngOnInit(): void {
    // this.idFor = this.activatedRoute.snapshot.params['id'];
    let id1 = this.activatedRoute.snapshot.paramMap.get('id');
    this.getId=id1;
    this.paymentDone=true;

//     this.activatedRoute.params.subscribe(params => {
//       const id = params['id'];
//       console.log('Url Id: ',id);
//       this.getId =id;
// })
this.getPoints();

      this.service.getContestFilmDetails().subscribe((res:any)=>{
      console.log('response', res);
      this.images = [...res]
    })

    this.service2.getUserId().subscribe((res: any) => {
      this.userId = res.user;
    });
    // this.getDrawingInfo(id1);
    
    this.service2.getDrawing(id1).subscribe((res:any)=>{
    
      console.log(res)
      this.drawingDetailsInfo = res;

  console.log(this.drawingDetailsInfo)
  console.log(this.drawingDetailsInfo.amountUserHas)
  console.log(this.drawingDetailsInfo.ticketPrice)
  console.log(this.drawingDetailsInfo.currentContest.customerImageUrl)

  this.currency = this.drawingDetailsInfo.amountUserHas;
  this.ticketPrice = this.drawingDetailsInfo.ticketPrice;
  this.drawingBannerUrl= this.drawingDetailsInfo.currentContest.customerImageUrl;
this.smallDesc=this.drawingDetailsInfo.currentContest.smallDescription;
this.largeDesc=this.drawingDetailsInfo.currentContest.largeDescription;
this.title=this.drawingDetailsInfo.currentContest.name;

this.winners=this.drawingDetailsInfo.winners;
this.tickets=this.drawingDetailsInfo.tickets;
console.log(this.winners)
if(this.winners == ''){
  this.showWinner = true;
}
  
    });
    this.getPrizes(id1);
    this.payId=id1;
  }

  getPoints(){
    this.service2.getPointsHistory().subscribe(res=>{
      console.log(res)
   
      this.currency = res;
  
          }) 
  }

  
getPrizes(id:any){
  this.service2.getPrizes(id).subscribe(res=>{
    console.log(res)

this.prize1Desc= res[0].prizeDescription;
this.prize2Desc= res[1].prizeDescription;
this.prize3Desc= res[2].prizeDescription;

  })

}
onStartClick(event:any) {
  console.log(event)

  this.startMin=event.target.value;
  console.log(this.startMin)
  console.log(event)

  this.payAmount= this.startMin*this.ticketPrice;
console.log(this.payAmount)

if(this.payAmount < this.currency){
  this.exceed = false;
  
}

}

onPay(){
this.paymentDone=false;
  this.service2.postDrawingTicket(this.payId,this.startMin,this.paymentType,this.startMin).subscribe(res=>{
    console.log(res)
    this.paymentDone =true;
  }),error=>{
    
      if(error == 200){
        console.log(error)

      
      }
      
  }
}
}